import React from 'react'

/**
 * Tells the donor how the parish uses donations, with an optional link to the
 * parish's own page. Renders nothing when the parish has published neither.
 */
export default function FundUseDisclosure({ parishName, fundUse }) {
  if (!fundUse || (!fundUse.text && !fundUse.url)) return null
  return (
    <p
      data-testid="fund-use-disclosure"
      className="text-xs text-charcoal-muted text-center mt-3"
    >
      {fundUse.text ? `How ${parishName} uses donations: ${fundUse.text}` : null}
      {fundUse.text && fundUse.url ? ' ' : null}
      {fundUse.url ? (
        <a
          href={fundUse.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="fund-use-link"
          className="text-gold font-semibold underline"
        >
          How {parishName} uses donations
        </a>
      ) : null}
    </p>
  )
}
